import { paths } from './paths.config';

export const weapons = {
  pew: {
    src: `${paths.audio.effects}/pew.mp3`,
    volume: 0.05,
  },
  blam: {
    src: `${paths.audio.effects}/pew2.mp3`,
    volume: 0.05,
  }
}